import type { ReactElement } from 'react'
import type { ViewModeSelectorProps } from '@/components/patterns/view-mode-selector'
import { ViewModeSelector } from '@/components/patterns/view-mode-selector'
import { Calendar, LayoutGrid, List } from 'lucide-react'

const layouts = [
  { value: 'list', label: 'List', icon: List },
  { value: 'grid', label: 'Grid', icon: LayoutGrid },
  { value: 'calendar', label: 'Calendar', icon: Calendar },
]

export function OrdersLayoutSelector({
  value,
  onValueChange,
}: Pick<ViewModeSelectorProps, 'value' | 'onValueChange'>): ReactElement {
  return (
    <ViewModeSelector
      value={value}
      onValueChange={onValueChange}
      options={layouts}
      label="Orders view"
    />
  )
}
